module.exports = __webpack_public_path__ + "media/images/flags/16/Cyprus-dac7d98e3e27926eb815e20333acf171.png";